"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import makeStyles from "../../theming/make-styles.js";
import { fade } from "../../theming/utils/color.js";
import Portal, { defaultContainer } from "../portal/portal.js";
const useStyles = makeStyles()((theme, { transparent }, classes) => ({
    backdrop: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1000,
        display: "block",
        background: transparent ? "rgba(255, 255, 255, 0.00001)" : fade(theme.colors.gray, 0.3),
        [`& ~ .${classes.backdrop}`]: {
            zIndex: 1001,
        },
    },
}));
export function Backdrop(_a) {
    var { className, container = defaultContainer, transparent = true } = _a, props = __rest(_a, ["className", "container", "transparent"]);
    const { classes, cx } = useStyles({ transparent });
    return (_jsx(Portal, { container: container, children: _jsx("div", Object.assign({ className: cx(classes.backdrop, className), "data-component": "backdrop" }, props)) }));
}
export default Backdrop;
//# sourceMappingURL=backdrop.js.map